module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "加减补课次数"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "classHourForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.classHourParam,
      "rules": _vm.classHourRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "加减补课次数",
      "prop": "num"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.classHourParam.num),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "num", _vm._n($$v))
      },
      expression: "classHourParam.num"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原因",
      "prop": "reason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.classHourParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "reason", $$v)
      },
      expression: "classHourParam.reason"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e76809b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserLessonNumModal.vue
// module id = 1905
// module chunks = 8